import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 13,
  path: '/analysis',
  component: Home,
  redirect: '/analysis/analysisAll/companyCollection',
  name: 'Analysis',
  isHead: true,
  meta: {
    title: '统计分析',
    icon: 'el-icon-data-analysis'
  },
  children: [
    {
      path: 'analysisAll',
      component: () => import('@/views/analysis/index'),
      name: 'AnalysisAll',
      meta: { title: '统计分析', close: false },
      children: [
        {
          path: 'companyCollection',
          component: () => import('@/views/analysis/companyCollection/index'),
          name: 'companyCollection',
          meta: { title: '企业信息采集率', next: '/analysis/analysisAll/informationCollection', close: false}
        }, {
          path: 'informationCollection',
          component: () => import('@/views/analysis/informationCollection/index'),
          name: 'informationCollection',
          meta: { title: '企业信息采集率二', next: '/analysis/analysisAll/scaleStatistical', close: false}
        }, {
          path: 'scaleStatistical',
          component: () => import('@/views/analysis/scaleStatistical/index'),
          name: 'scaleStatistical',
          meta: { title: '企业规模统计', next: '/analysis/analysisAll/industryStatistical', close: false}
        }, {
          path: 'industryStatistical',
          component: () => import('@/views/analysis/industryStatistical/index'),
          name: 'industryStatistical',
          meta: { title: '行业类型统计', next: '/analysis/analysisAll/starStatistical', close: false}
        }, {
          path: 'starStatistical',
          component: () => import('@/views/analysis/starStatistical/index'),
          name: 'starStatistical',
          meta: { title: '丰泽区星级评定统计', next: '/analysis/analysisAll/userLoginStatistical', close: false}
        }, {
          path: 'userLoginStatistical',
          component: () => import('@/views/analysis/userLoginStatistical/index'),
          name: 'userLoginStatistical',
          meta: { title: '企业端用户登录情况统计表', next: '/analysis/analysisAll/superviseLoginStatistical', close: false}
        }, {
          path: 'superviseLoginStatistical',
          component: () => import('@/views/analysis/superviseLoginStatistical/index'),
          name: 'superviseLoginStatistical',
          meta: { title: '监管端用户登录情况统计表', next: '/analysis/analysisAll/threeList', close: false}
        }, {
          path: 'threeList',
          name: 'threeList',
          component: () => import('@/views/analysis/threeList/index'),
          meta: {title: '企业三张清单进度表', next: '/analysis/analysisAll/dynamicMonitoring', close: true}
        }, {
          path: 'dynamicMonitoring',
          name: 'dynamicMonitoring',
          component: () => import('@/views/analysis/dynamicMonitoring/index'),
          meta: {title: '四色安全风险动态监督', next: '/analysis/analysisAll/hiddenStatistical', close: true}
        }, {
          path: 'promotion',
          name: 'promotion',
          component: () => import('@/views/analysis/promotion/index'),
          meta: {title: '安全生产标准化提升', next: '/analysis/analysisAll/threeList', close: true}
        }, {
          path: 'hiddenStatistical',
          name: 'hiddenStatistical',
          component: () => import('@/views/analysis/hiddenStatistical'),
          meta: {title: '隐患排查统计', next: '/analysis/analysisAll/performanceStatistical', close: true}
        }, {
          path: 'performanceStatistical',
          name: 'performanceStatistical',
          component: () => import('@/views/analysis/performanceStatistical'),
          meta: {title: '重大隐患专项绩效统计', next: '/analysis/analysisAll/specialPerformanceStatistical', close: true}
        }, {
          path: 'specialPerformanceStatistical',
          name: 'specialPerformanceStatistical',
          component: () => import('@/views/analysis/specialPerformanceStatistical'),
          meta: {title: '重大隐患专项绩效统计二', next: '/analysis/analysisAll/safeStatistical', close: true}
        }, {
          path: 'safeStatistical',
          name: 'safeStatistical',
          component: () => import('@/views/analysis/safeStatistical'),
          meta: {title: '安全风险管控统计', next: '/analysis/analysisAll/superviseStatistical', close: true}
        }, {
          path: 'superviseStatistical',
          name: 'superviseStatistical',
          component: () => import('@/views/analysis/superviseStatistical'),
          meta: {title: '监督检查隐患统计', next: '/analysis/analysisAll/nineBaseInfoReport', close: true}
        }
      ]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/analysis.js